<template>
  <el-card class="setting">
    <el-row :gutter="20">
      <el-col
        :span="11"
        class="border m-r-10 m-l-15"
      >
        <div class="classify-title">
          店铺信息
          <div
            class="edit"
            @click="toUpdateStore"
          >
            <i class="fa fa-edit" />
          </div>
        </div>
        <el-form label-width="80px">
          <el-form-item label="店铺名称">
            <div v-if="!editable">
              {{ storeInfo.storeName }}
            </div>
            <el-input
              v-else
              v-model.trim="storeInfo.storeName"
              placeholder="请输入32字以内的店铺名称"
              maxlength="32"
            />
          </el-form-item>
          <el-form-item label="店铺logo">
            <upload
              v-if="editable"
              :image-url="storeInfo.storeLogo ? [{url:storeInfo.storeLogo}] :[]"
              @returnFileInfo="returnFileInfo"
            />
            <upload
              v-else
              :is-watch="!createContactVisible && !contactList.find(item=>item.hasOwnProperty('editable')) "
              :disabled="true"
              :image-url="storeInfo.storeLogo ? [{url:storeInfo.storeLogo}] :[]"
            />
          </el-form-item>
          <el-form-item
            label="店铺简介"
            class="desc"
          >
            <div v-if="!editable">
              {{ storeInfo.storeDesc }}
            </div>
            <el-input
              v-else
              v-model.trim="storeInfo.storeDesc"
              type="textarea"
              placeholder="请输入300字以内的店铺简介"
              maxlength="300"
              :autosize="{ minRows: 3, maxRows: 6}"
            />
          </el-form-item>
          <!-- <el-form-item label="店铺状态">
            <div v-if="!editable">{{storeInfo.storeName}}</div>
            <el-radio-group v-else v-model="storeInfo.actionType">
              <el-radio v-for="item in $key.myStore.actionType" :key="item.id" :label="item.id">{{item.name}}</el-radio>
            </el-radio-group>
          </el-form-item> -->
        </el-form>
        <div
          v-if="editable"
          class="m-t-30 m-b-10 text-c"
        >
          <el-button
            type="primary"
            @click="toSubmitStoreSetting"
          >
            确认
          </el-button>
          <el-button @click="editable=false">
            取消
          </el-button>
        </div>
      </el-col>
      <el-col
        :span="11"
        class="border m-l-10"
      >
        <div class="classify-title">
          联系人设置
        </div>
        <el-table
          :data="contactList"
        >
          <af-table-column
            prop="remark"
            label="联系人"
          >
            <template v-slot="scope">
              <div v-if="!scope.row.editable">
                {{ scope.row.remark }}
              </div>
              <el-input
                v-else
                v-model.trim="scope.row.remark"
              />
            </template>
          </af-table-column>
          <af-table-column
            prop="content"
            label="联系方式"
          >
            <template v-slot="scope">
              <div v-if="!scope.row.editable">
                {{ scope.row.content }}
              </div>
              <el-input
                v-else
                v-model.trim="scope.row.content"
              />
            </template>
          </af-table-column>
          <af-table-column
            prop="totalQuantity"
            label="操作"
          >
            <template v-slot="scope">
              <el-button
                v-if="!scope.row.editable"
                type="text"
                @click="toUpdateContact(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-else
                type="text"
                @click="toSubmitUpdateContact(scope.row)"
              >
                确定
              </el-button>
              <el-button
                v-if="scope.row.editable"
                type="text"
                @click="toCancelContact(scope.row)"
              >
                取消
              </el-button>
              <el-button
                type="text"
                class="red"
                @click="toDeleteContact(scope.row)"
              >
                删除
              </el-button>
            </template>
          </af-table-column>
        </el-table>
        <el-button
          size="small"
          type="primary"
          class="m-b-10 m-t-10"
          @click="toCreateContact"
        >
          新增
        </el-button>
        <el-form
          v-show="createContactVisible"
          label-width="80px"
          inline
        >
          <el-form-item
            label="联系人"
            required
          >
            <el-input v-model.trim="contactInfo.remark" />
          </el-form-item>
          <el-form-item
            label="联系方式"
            required
          >
            <el-input v-model.trim="contactInfo.content" />
          </el-form-item>
        </el-form>
        <div
          v-show="createContactVisible"
          class="m-t-30 m-b-10 text-c"
        >
          <el-button
            type="primary"
            @click="toSubmitContact"
          >
            确认
          </el-button>
          <el-button @click="createContactVisible=false">
            取消
          </el-button>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import api from '@/api'
import Upload from '@/components/upload'
import { mapState } from 'vuex'

export default {
  name: 'StoreSetting',
  components: {
    Upload
  },
  props: {
    issueTradeVisible: {
      type: Boolean,
      default: false,
    },
    detailData: {
      type: Object,
      default: () => { return { priceList: [] } }
    },
  },
  data () {
    return {
      editable: false,
      storeInfo: {},
      contactInfo: {
        content: '',
        remark: ''
      },
      contactList: [],
      createContactVisible: false,
      tempContact: {
        name: '',
        phone: '',
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.info
    })
  },
  created () {
    this.getStoreDetail()
    this.getContact()
  },
  methods: {
    // 店铺信息
    getStoreDetail () {
      api.myStore.getStoreDetail().then(res => {
        this.storeInfo = { ...this.storeInfo, ...res.data }
      })
    },
    returnFileInfo (data) {
      this.storeInfo.storeLogo = data && data.length ? data[0].url : ''
    },
    // 去编辑店铺
    toUpdateStore (row) {
      this.editable = true
    },
    // 提交店铺编辑
    toSubmitStoreSetting () {
      api.myStore.updateStroe(this.storeInfo).then(res => {
        this.$message.success('操作成功')
        this.getStoreDetail()
        this.editable = false
      })
    },
    // 获取联系人列表
    getContact () {
      api.myStore.getContact(this.userInfo.userId).then(res => {
        this.contactList = res.data
      })
    },
    // 点击新增联系方式
    toCreateContact () {
      this.createContactVisible = true
      this.contactInfo = {
        content: '',
        remark: ''
      }
    },
    // 提交新增
    toSubmitContact () {
      if (!this.contactInfo.content || !this.contactInfo.remark) {
        this.$message.warning('联系人和联系方式必传')
        return
      }
      const param = {
        objectId: this.userInfo.userId,
        parentObjectId: this.userInfo.customerId,
        type: 'CONTACT',
        represent: 'SHOP_MOBILE',
        ...this.contactInfo,
      }
      api.myStore.createContact(param).then(res => {
        this.createContactVisible = false
        this.getContact()
      })
    },
    // 编辑联系人
    toUpdateContact (row) {
      this.createContactVisible = false
      this.$set(row, 'editable', true)
      this.tempContact = {
        name: row.remark,
        phone: row.content,
      }
    },
    // 取消编辑联系人
    toCancelContact (row) {
      row.editable = false
      row.remark = this.tempContact.name
      row.content = this.tempContact.phone
    },
    // 提交编辑
    toSubmitUpdateContact (row) {
      const param = {
        id: row.id,
        type: 'CONTACT',
        represent: 'SHOP_MOBILE',
        content: row.content,
        remark: row.remark,
      }
      api.myStore.updateContact(param).then(res => {
        this.getContact()
      })
    },
    // 删除联系方式
    toDeleteContact (row) {
      this.$confirm('确认删除改联系人?', '提示', {
        type: 'warning'
      }).then(() => {
        api.myStore.deleteContact(row.id).then(res => {
          this.getContact()
        })
      }).catch(() => {

      })
    },

  },
}
</script>

<style lang="scss">
.setting {
  .edit {
    float: right;
    cursor: pointer;
  }
  .border {
    border: 1px solid #dfdfdf;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
  }
  .desc {
    word-break: break-all;
  }
}

</style>
